// Google 工具自动生成
// 不要修改! 不要修改!! 不要修改!!!
/* eslint-disable */
var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.PCMMessage', null, global);
goog.exportSymbol('proto.PCMMessageContext', null, global);
goog.exportSymbol('proto.PCMMessageModule', null, global);
goog.exportSymbol('proto.PCMResponseStatus', null, global);
goog.exportSymbol('proto.PCMessageType', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PCMMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PCMMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.PCMMessage.displayName = 'proto.PCMMessage';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.PCMMessage.prototype.toObject = function(opt_includeInstance) {
    return proto.PCMMessage.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.PCMMessage} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.PCMMessage.toObject = function(includeInstance, msg) {
    var f,
      obj = {
        msgmodule: jspb.Message.getFieldWithDefault(msg, 1, 0),
        msgtype: jspb.Message.getFieldWithDefault(msg, 2, 0),
        msgcategory: jspb.Message.getFieldWithDefault(msg, 3, ''),
        messageid: jspb.Message.getFieldWithDefault(msg, 4, 0),
        messageproto: msg.getMessageproto_asB64(),
        extend: jspb.Message.getFieldWithDefault(msg, 7, ''),
        responsestatus: jspb.Message.getFieldWithDefault(msg, 8, 0),
        identiy: jspb.Message.getFieldWithDefault(msg, 9, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PCMMessage}
 */
proto.PCMMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PCMMessage();
  return proto.PCMMessage.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PCMMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PCMMessage}
 */
proto.PCMMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!proto.PCMMessageModule} */ (reader.readEnum());
        msg.setMsgmodule(value);
        break;
      case 2:
        var value = /** @type {!proto.PCMessageType} */ (reader.readEnum());
        msg.setMsgtype(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setMsgcategory(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setMessageid(value);
        break;
      case 5:
        var value = /** @type {!Uint8Array} */ (reader.readBytes());
        msg.setMessageproto(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setExtend(value);
        break;
      case 8:
        var value = /** @type {!proto.PCMResponseStatus} */ (reader.readEnum());
        msg.setResponsestatus(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setIdentiy(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PCMMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PCMMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PCMMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PCMMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsgmodule();
  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }
  f = message.getMsgtype();
  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
  f = message.getMsgcategory();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getMessageid();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getMessageproto_asU8();
  if (f.length > 0) {
    writer.writeBytes(5, f);
  }
  f = message.getExtend();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getResponsestatus();
  if (f !== 0.0) {
    writer.writeEnum(8, f);
  }
  f = message.getIdentiy();
  if (f !== 0) {
    writer.writeInt32(9, f);
  }
};

/**
 * optional PCMMessageModule msgmodule = 1;
 * @return {!proto.PCMMessageModule}
 */
proto.PCMMessage.prototype.getMsgmodule = function() {
  return /** @type {!proto.PCMMessageModule} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {!proto.PCMMessageModule} value */
proto.PCMMessage.prototype.setMsgmodule = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};

/**
 * optional PCMessageType msgtype = 2;
 * @return {!proto.PCMessageType}
 */
proto.PCMMessage.prototype.getMsgtype = function() {
  return /** @type {!proto.PCMessageType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {!proto.PCMessageType} value */
proto.PCMMessage.prototype.setMsgtype = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

/**
 * optional string msgcategory = 3;
 * @return {string}
 */
proto.PCMMessage.prototype.getMsgcategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.PCMMessage.prototype.setMsgcategory = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int32 messageid = 4;
 * @return {number}
 */
proto.PCMMessage.prototype.getMessageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.PCMMessage.prototype.setMessageid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional bytes messageproto = 5;
 * @return {!(string|Uint8Array)}
 */
proto.PCMMessage.prototype.getMessageproto = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/**
 * optional bytes messageproto = 5;
 * This is a type-conversion wrapper around `getMessageproto()`
 * @return {string}
 */
proto.PCMMessage.prototype.getMessageproto_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(this.getMessageproto()));
};

/**
 * optional bytes messageproto = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessageproto()`
 * @return {!Uint8Array}
 */
proto.PCMMessage.prototype.getMessageproto_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(this.getMessageproto()));
};

/** @param {!(string|Uint8Array)} value */
proto.PCMMessage.prototype.setMessageproto = function(value) {
  jspb.Message.setProto3BytesField(this, 5, value);
};

/**
 * optional string extend = 7;
 * @return {string}
 */
proto.PCMMessage.prototype.getExtend = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.PCMMessage.prototype.setExtend = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional PCMResponseStatus responsestatus = 8;
 * @return {!proto.PCMResponseStatus}
 */
proto.PCMMessage.prototype.getResponsestatus = function() {
  return /** @type {!proto.PCMResponseStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};

/** @param {!proto.PCMResponseStatus} value */
proto.PCMMessage.prototype.setResponsestatus = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};

/**
 * optional int32 identiy = 9;
 * @return {number}
 */
proto.PCMMessage.prototype.getIdentiy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};

/** @param {number} value */
proto.PCMMessage.prototype.setIdentiy = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PCMMessageContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PCMMessageContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.PCMMessageContext.displayName = 'proto.PCMMessageContext';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.PCMMessageContext.prototype.toObject = function(opt_includeInstance) {
    return proto.PCMMessageContext.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.PCMMessageContext} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.PCMMessageContext.toObject = function(includeInstance, msg) {
    var f,
      obj = {
        context1: jspb.Message.getFieldWithDefault(msg, 1, ''),
        context2: jspb.Message.getFieldWithDefault(msg, 2, ''),
        context3: jspb.Message.getFieldWithDefault(msg, 3, ''),
        context4: jspb.Message.getFieldWithDefault(msg, 4, ''),
        context5: jspb.Message.getFieldWithDefault(msg, 5, ''),
        context6: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PCMMessageContext}
 */
proto.PCMMessageContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PCMMessageContext();
  return proto.PCMMessageContext.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PCMMessageContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PCMMessageContext}
 */
proto.PCMMessageContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setContext1(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setContext2(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setContext3(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setContext4(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setContext5(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setContext6(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PCMMessageContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PCMMessageContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PCMMessageContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PCMMessageContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContext1();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getContext2();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getContext3();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getContext4();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getContext5();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getContext6();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional string context1 = 1;
 * @return {string}
 */
proto.PCMMessageContext.prototype.getContext1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.PCMMessageContext.prototype.setContext1 = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string context2 = 2;
 * @return {string}
 */
proto.PCMMessageContext.prototype.getContext2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.PCMMessageContext.prototype.setContext2 = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string context3 = 3;
 * @return {string}
 */
proto.PCMMessageContext.prototype.getContext3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.PCMMessageContext.prototype.setContext3 = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string context4 = 4;
 * @return {string}
 */
proto.PCMMessageContext.prototype.getContext4 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.PCMMessageContext.prototype.setContext4 = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string context5 = 5;
 * @return {string}
 */
proto.PCMMessageContext.prototype.getContext5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.PCMMessageContext.prototype.setContext5 = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string context6 = 6;
 * @return {string}
 */
proto.PCMMessageContext.prototype.getContext6 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.PCMMessageContext.prototype.setContext6 = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * @enum {number}
 */
proto.PCMMessageModule = {
  PCM_MESSAGE_MODULE_COMMON: 0,
  PCM_MESSAGE_MODULE_OPTIMIZE: 1,
  PCM_MESSAGE_MODULE_PROTECT: 2,
  PCM_MESSAGE_MODULE_HARDWARE: 3,
  PCM_MESSAGE_MODULE_DRIVER: 4,
  PCM_MESSAGE_MODULE_SERVICE: 5,
  PCM_MESSAGE_MODULE_FLOATINGWINDOW: 6,
  PCM_MESSAGE_MODULE_WSPLUGIN: 7,
  PCM_MESSAGE_MODULE_SMARTHOME: 8,
  PCM_MESSAGE_MODULE_SECURITY: 9,
};

/**
 * @enum {number}
 */
proto.PCMessageType = {
  PCM_MESSAGE_TYPE_NOTIFY: 0,
  PCM_MESSAGE_TYPE_REQUEST: 1,
  PCM_MESSAGE_TYPE_RESPONSE: 2,
};

/**
 * @enum {number}
 */
proto.PCMResponseStatus = {
  PCM_RESPONSE_STATUS_NONE: 0,
  PCM_RESPONSE_STATUS_ONGOING: 1,
  PCM_RESPONSE_STATUS_FINISH: 2,
  PCM_RESPONSE_STATUS_FAILED: 3,
  PCM_RESPONSE_STATUS_CANCEL: 4,
};

goog.object.extend(exports, proto);
